import { render, staticRenderFns } from "./IsVariantComponent.vue?vue&type=template&id=187f6446&"
import script from "./IsVariantComponent.vue?vue&type=script&lang=js&"
export * from "./IsVariantComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports